define(function () {
    return location.protocol + '//tpc.googlesyndication.com';
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/commercial/modules/messenger/dfp-origin.js
// module id = 532
// module chunks = 1